import { clevertapEvent } from 'utils/clevertap';
import { EVENT_NAME } from './constants';

export const trackerLoginAttempt = () =>
  clevertapEvent(EVENT_NAME.NEW_DEVICE_LOGIN_ATTEMPT);

export const trackerPromptSent = () =>
  clevertapEvent(EVENT_NAME.PROMPT_SENT_TO_TRUSTED_DEVICE);

export const trackerIdentityVerificationStarted = () =>
  clevertapEvent(EVENT_NAME.FALLBACK_IDENTITY_VERIFICATION_STARTED);

export const trackerIdentityVerificationFailed = () =>
  clevertapEvent(EVENT_NAME.MANUAL_VERIFICATION_FAILED);

export const trackerInputPasswordSuccess = () =>
  clevertapEvent(EVENT_NAME.NEW_DEVICE_LOGIN_INPUT_PASSWORD_SUCCESS);

export const trackerInputPinSuccess = () =>
  clevertapEvent(EVENT_NAME.NEW_DEVICE_LOGIN_INPUT_PIN_SUCCESS);

export const trackerOtpVerified = () =>
  clevertapEvent(EVENT_NAME.NEW_DEVICE_LOGIN_OTP_VERIFIED);

export const trackerLoginCompleted = () =>
  clevertapEvent(EVENT_NAME.NEW_DEVICE_LOGIN_COMPLETED);
